import http from "./httpService";

export function getGradosDocente( docente ) {
    let apiEndPoint = `/Grados/docente`;

    if (docente > 0)
        apiEndPoint = `${apiEndPoint}/${docente}`;

    return http.get(apiEndPoint);
}